import * as React from 'react';
import clsx from 'clsx';

import { StoreType, useActions } from 'utils/connect';
import { Toast as ToastType } from '@tock/toast';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Portal from '@tock/shared/components/Portal';

const errorTimeout = 10000;
const infoTimeout = 6000;

const Toast = () => {
  const toasts = useSelector((state: StoreType) => state.toast);

  return (
    <Portal isOpen={true}>
      {toasts.map((t) => (
        <ToastBody key={t.id} {...t} />
      ))}
    </Portal>
  );
};

const ToastBody: React.FC<ToastType> = ({ id, message, onClickLink, onClear, type, linkText }) => {
  const { actions } = useActions();

  useEffect(() => {
    const timerId = setTimeout(
      () => {
        actions.toast.remove(id);
      },
      type === 'info' ? infoTimeout : errorTimeout
    );

    return () => clearTimeout(timerId);
  }, [actions.toast, id, type]);

  const isOpen = !!message;
  const toastClassNames = clsx('Toast', {
    'is-error': type === 'error',
    'is-visible': isOpen,
  });

  return (
    <div
      className={toastClassNames}
      onClick={() => {
        actions.toast.remove(id);
        onClear?.();
      }}
      data-testid="toast"
    >
      <span className="Toast-text">
        {message}
        &nbsp;
        {linkText && (
          <a className="Toast-link" href="#" onClick={onClickLink}>
            {linkText}
          </a>
        )}
      </span>
    </div>
  );
};

export default Toast;
